/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    pre: "pre",
    code: "code",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Send down component props"
    }), "\n", _jsx(_components.p, {
      children: "You can use the Provider to send down component props. And because providers can be nested, it's a really powerful tool to handle generally properties used often by a component."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import Provider from '@dnb/eufemia/shared/Provider'\n\nrender(\n  <MyApp>\n    ...\n    <Provider Button={{ size: 'large' }}>\n      ...\n      <Button>Large button</Button>\n    </Provider>\n  </MyApp>,\n)\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "NB:"
      }), " If you use TypeScript, you may rather use the ", _jsx(_components.code, {
        children: "value"
      }), " prop to spread the component properties along:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "<Provider\n  value={{\n    Button: { size: 'large' },\n  }}\n>\n  ...\n  <Button>Large button</Button>\n</Provider>\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Changing locale or currency"
    }), "\n", _jsxs(_components.p, {
      children: ["You can either set the locale as a properly e.g. ", _jsx(_components.code, {
        children: "<Provider locale=\"en-GB\" ..."
      }), " and handle the change from the app root, or change it inside the app, respective Context:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { Field } from '@dnb/eufemia/extensions/forms'\nimport Provider from '@dnb/eufemia/shared/Provider'\nimport Context from '@dnb/eufemia/shared/Context'\n\nconst ChangeLocale = () => {\n  const { setLocale, update, locale } = React.useContext(Context)\n\n  React.useEffect(() => {\n    // Change the locale\n    update({ locale: 'en-GB' })\n\n    // Change the default currency\n    update({ currency: 'USD' })\n  }, [])\n\n  return (\n    <Field.Selection value={locale} onChange={(value) => setLocale(value)}>\n      <Field.Option value=\"nb-NO\" title=\"Norsk\" />\n      <Field.Option value=\"en-GB\" title=\"English (GB)\" />\n    </Field.Selection>\n  )\n}\n\nrender(\n  <Provider>\n    <MyApp>\n      <ChangeLocale />\n      text <NumberFormat>123</NumberFormat> table etc.\n    </MyApp>\n  </Provider>,\n)\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Nested Providers"
    }), "\n", _jsx(_components.p, {
      children: "Yes, it's possible to have nested providers."
    }), "\n", _jsx(_components.p, {
      children: "You have then to decide what you need to update."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { Field } from '@dnb/eufemia/extensions/forms'\nimport Provider from '@dnb/eufemia/shared/Provider'\nimport Context from '@dnb/eufemia/shared/Context'\n\nconst ChangeLocale = () => {\n  const { setCurrentLocale, updateCurrent, locale } =\n    React.useContext(Context)\n\n  React.useEffect(() => {\n    // Change the locale\n    updateCurrent({ locale: 'en-GB' })\n\n    // Change the default currency\n    updateCurrent({ currency: 'USD' })\n  }, [])\n\n  return (\n    <Field.Selection\n      value={locale}\n      onChange={(value) => setCurrentLocale(value)}\n    >\n      <Field.Option value=\"nb-NO\" title=\"Norsk\" />\n      <Field.Option value=\"en-GB\" title=\"English (GB)\" />\n    </Field.Selection>\n  )\n}\n\nrender(\n  <Provider locale=\"en-GB\">\n    <MyApp>\n      <Provider locale=\"nb-NO\">\n        Norsk <NumberFormat>1234</NumberFormat>\n        <ChangeLocale />\n      </Provider>\n      English <NumberFormat>1234</NumberFormat>\n    </MyApp>\n  </Provider>,\n)\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Provider and context troubleshooting"
    }), "\n", _jsx(_components.p, {
      children: "If there is a module format deviation, components do not share anymore the same provider and context. So, make sure you have a consistent import routine, not like this:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "// NB: Example of deviant module formats\nimport Provider from '@dnb/eufemia/shared/Provider' // like /esm\nimport { Button } from '@dnb/eufemia/es'\nimport { NumberFormat } from '@dnb/eufemia/cjs/components'\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
